import type { DriverStatus, VehicleStatus, VehicleType } from "@/features/fleet/types";

export const DRIVER_STATUSES: { value: DriverStatus; label: string }[] = [
  { value: "active", label: "Active" },
  { value: "inactive", label: "Inactive" },
  { value: "on_leave", label: "On leave" },
];

export const VEHICLE_STATUSES: { value: VehicleStatus; label: string }[] = [
  { value: "available", label: "Available" },
  { value: "on_trip", label: "On trip" },
  { value: "inactive", label: "Inactive" },
];

export const VEHICLE_TYPES: { value: VehicleType; label: string }[] = [
  { value: "truck", label: "Truck" },
  { value: "trailer", label: "Trailer" },
  { value: "tempo", label: "Tempo" },
  { value: "container", label: "Container" },
  { value: "other", label: "Other" },
];

export function labelFor<T extends string>(
  options: { value: T; label: string }[],
  value: T | string | null | undefined,
) {
  if (!value) return "—";
  return options.find((o) => o.value === value)?.label ?? value;
}

export function vehicleStatusTone(
  status: VehicleStatus,
): "success" | "warning" | "neutral" {
  if (status === "available") return "success";
  if (status === "on_trip") return "warning";
  return "neutral";
}

export function driverStatusTone(
  status: DriverStatus,
): "success" | "warning" | "neutral" {
  if (status === "active") return "success";
  if (status === "on_leave") return "warning";
  return "neutral";
}
